var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar',{attrs:{"info":_vm.info,"notifications":_vm.notifications}}),_vm._v(" "),_c('router-view',{attrs:{"info":_vm.info,"notifications":_vm.notifications}}),_vm._v(" "),_c('error-messages',{attrs:{"show5XXError":""}}),_vm._v(" "),_c('page-footer'),_vm._v(" "),(_vm.isIdle)?_c('idle-modal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }